import { Injectable } from '@angular/core';
import { global } from '../../models/global';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import 'rxjs/add/Observable/throw';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { debounce } from 'rxjs/operator/debounce';
import { DebugElement } from '@angular/core/src/debug/debug_node';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';

@Injectable({
  providedIn: 'root'
})
export class DemoSampleAllocationService {

  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  getRequirementType(userId: string, roleId: string): Observable<any> {
    let url = this.ROOT_URL + '/api/DemoSampleAllocation/GetRequirementType';
    let body = { "userId": userId, "roleId": roleId };
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  getRoleCode(userId: string, roleId: string): Observable<any> {
    let url = this.ROOT_URL + '/api/DemoSampleAllocation/GetRoleCode';
    let body = { "userId": userId, "roleId": roleId };
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  getEmployeeName(userId: string, roleId: string, sbuCode: string, divisionCode: string, zoneCode: string, regionCode: string, selectedRole: string): Observable<any> {
    let url = this.ROOT_URL + '/api/DemoSampleAllocation/GetEmployeeName';
    let body = { "userId": userId, "roleId": roleId, "sbuCode": sbuCode, "divisionCode": divisionCode, "zoneCode": zoneCode, "regionCode": regionCode, "selectedRole": selectedRole };
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  getDemoSampleAllocationDetails(userId: string, roleId: string, sbuCode: string, divisionCode: string, zoneCode: string, regionCode: string, reqType: string, selectedRole: string, employeeName: string,commaSeperatedStatus:string,commaSeperatedProduct:string, designation:string,year:any): Observable<any> {
    let url = this.ROOT_URL + '/api/DemoSampleAllocation/GetDemoSampleAllocationDetails';
    let body = { "userId": userId, "roleId": roleId, "sbuCode": sbuCode, "divisionCode": divisionCode, "zoneCode": zoneCode, "regionCode": regionCode, "reqType": reqType, "selectedRole": selectedRole, "employeeName": employeeName,"commaSeperatedStatus":commaSeperatedStatus,"commaSeperatedProduct":commaSeperatedProduct, "designation":designation,"year":year};
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  downloadExcel(model: any): Observable<any> {
    //debugger
    let _body = JSON.stringify(model);
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/DemoSampleAllocation/ExcelDownload",
      headers: headers,
      body: _body,
      responseType: ResponseContentType.Blob
    });
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
  downloadExcelForMobile(model: any): Observable<any> {
    let url = this.ROOT_URL + '/api/DropDown/GetRegionWise';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url:  this.ROOT_URL + "/api/DemoSampleAllocation/ExcelDownloadForMobile",
        headers: headers,
        body: JSON.stringify(model)
    })
    return this.http.request(new Request(requestoptions))
        // .map(response => <any>(<Response>response));
        .map(response => <any>(<Response>response).json());

    
}


  uploadDocument(documents: File, userId: string,roleId: string,reqType:string,isSubmitted:string,year:any): Observable<any> {
    const formData = new FormData();
    formData.append("file", documents);
    formData.append("UserId", userId);
    formData.append("RoleId", roleId);
    formData.append("ReqType", reqType);
    formData.append("Year", year);
  //   const data = {
  //     isSubmitted: "IsSubmitted"
  // };
  // formData .append('IsSubmitted', JSON.stringify(data));
    formData.append("isSubmitted", isSubmitted);
    let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/DemoSampleAllocation/UploadFiles",
      headers: headers,
      body: formData
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }

  submitDemoSampleAllocationData(item:any,userId: string, roleId: string,reqType:string,isSubmitted:string,year:any): Observable<any> {
    
    let url = this.ROOT_URL + '/api/DemoSampleAllocation/SubmitDemoSampleAllocationDetails';
    let body = { "model":item,"userId": userId, "roleId": roleId, "reqType":reqType,"isSubmitted":isSubmitted,"year":year};
    console.log(body);
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }



  UpdateSubmitDemoSampleAllocationData(requestNo:string,product:string,region:string,miomdoUserID:string): Observable<any> {
    
    let url = this.ROOT_URL + '/api/DemoSampleAllocation/UpdateSubmitDemoSampleAllocationDetails';
    let body = { "requestNo": requestNo, "product": product, "region":region,"miomdoUserID":miomdoUserID};
    console.log(body);
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }




  GetDemoSampleData(id: string, reqType:string,year:number): Observable<any> {
    
    let url = this.ROOT_URL + '/api/DemoSampleAllocation/GetDemoSampleData';
    let body = { "id": id,  "reqType":reqType,"year":year,};
    console.log(body);
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }
}